module.exports = __webpack_public_path__ + "static/media/lenen_bank.1ae2d9ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/lenen_bank.svg
// module id = 943
// module chunks = 0